module.exports = __webpack_public_path__ + "img/5032971cd0dd3c954ee80a3e51c0207a.7598077d.png";